// Charge la base commune
import './common.js'

// charge bootstrap Tabs et Scrollspy
import 'bootstrap/js/dist/scrollspy'
import 'bootstrap/js/dist/tab'

// Styles custom
import './scss/pages/grounds.detail.scss'

// Styles librairies
import './js/libs/responsive-bs-tabs-dropdown/dist/css/responsive-tabs.css'

// Scripts librairies
import { dtectMap } from './js/libs/utils'
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.min.js'
import './js/libs/responsive-bs-tabs-dropdown/dist/js/responsive-tabs.js'

// rafraîchissement
function r () {
  Waypoint.refreshAll()
}

// OwlCarousel
async function getOwlCarousel () {
  import(/* webpackChunkName: "owl-carousel" */ './js/components/owl-carousel.js').then(() => {
    r()
  })
}

// Grounds Map
async function getGroundsMap ($f) {
  import(/* webpackChunkName: "grounds-map", webpackPrefetch: true */ './js/components/grounds-map.js').then(() => {
    $f.load(false)
  })
}

// Custom Lists
async function getCustomLists () {
  import(/* webpackChunkName: "custom-lists" */ './js/components/custom-lists.js').then(() => {
    r()
  })
}

// Contact Form
async function getContactForm ($f) {
  import(/* webpackChunkName: "contact-form" */ './js/components/contact-form.js').then(() => {
    $f.load(false)
    r()
  })
}

// Agency autocomplete
async function getAgencyAutocomplete ($f) {
  import(/* webpackChunkName: "quick-agency-search-form" */ './js/components/quick-agency-search-form.js').then(module => {
    const form = module.qasForm
    form.init($f)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des carousel
  const $d = $('.owl-carousel.c')
  if ($d.length) {
    $d.waypoint(function () {
      getOwlCarousel()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des scrollbars améliorées
  const $c = $('.custom-lists')
  if ($c.length) {
    $c.waypoint(function () {
      getCustomLists()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $f = $('.contact-form')
  if ($f.length) {
    $f.waypoint(function () {
      $f.load()
      getContactForm($f)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // filtres des agences autocomplete
  $('form[name="qasForm"] input[name="search"]').on('click', function () {
    $(this).blur().off('click').attr('disabled', '')
    getAgencyAutocomplete($(this).parents('form'))
  })

  // boutons d'action sur le terrain détaillé
  if (typeof (googleanalytics) !== 'undefined') {
    $('#track-f').on('click', function () { // event sur bouton financement : track event google analytics
      /* global ga */
      ga('send', 'event', 'Financement terrain', 'Clic')
      /* global gtag */
      if (typeof (googletag) !== 'undefined') { gtag('event', 'financing', { element: 'ground' }) }
    })
    $('#track-c, #track-c2').on('click', function () { // event sur bouton contact : track event google analytics
      ga('send', 'event', 'Contacter terrain', 'Clic')
      if (typeof (googletag) !== 'undefined') { gtag('event', 'contact', { subject: 'ground' }) }
    })
    $('#track-m').on('click', function () { // event sur bouton modèle
      ga('send', 'event', 'Recherche modele', 'Clic')
      if (typeof (googletag) !== 'undefined') { gtag('event', 'find_model') }
    })
  }

  // tabs
  $('.nav-tabs').responsiveTabs()

  // refresh waypoints au chargement d'une image
  $('.lazyload').on('lazyloaded', () => {
    r()
  })

  // wait until gmap is correctly loading
  dtectMap(function () {
    // gestion de la carte des terrains
    const $m = $('#grounds-map')
    if ($m.length) {
      $m.waypoint(function () {
        $m.load()
        getGroundsMap($m)
        this.destroy()
      }, {
        offset: '100%'
      })
    }
  })
})
